import React from 'react';
import { Box, Typography, Button, Chip, CircularProgress } from '@mui/material';
import { Edit, AlertTriangle, Clock, CheckCircle, XCircle, Calendar } from 'react-feather';
import { statusColors, defaultStatus } from './mockData';

const TicketHeader = ({ ticket, editMode, toggleEditMode, loading, saveChanges }) => {
    // Get status icon component
    const getStatusIcon = (status) => {
        if (!status) return <AlertTriangle size={14} />;

        const iconType = statusColors[status]?.icon || defaultStatus.icon;
        switch (iconType) {
            case 'AlertTriangle':
                return <AlertTriangle size={14} />;
            case 'Clock':
                return <Clock size={14} />;
            case 'CheckCircle':
                return <CheckCircle size={14} />;
            case 'XCircle':
                return <XCircle size={14} />;
            case 'Calendar':
                return <Calendar size={14} />;
            default:
                return <AlertTriangle size={14} />;
        }
    };

    // Get status color
    const getStatusColor = (status) => {
        if (!status) return defaultStatus;
        return statusColors[status] || defaultStatus;
    };

    return (
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                Ticket {ticket.id}
            </Typography>
            <Box sx={{ display: 'flex', gap: 1 }}>
                {editMode ? (
                    <>
                        <Button
                            variant="outlined"
                            size="small"
                            onClick={toggleEditMode}
                            sx={{ borderRadius: '8px', textTransform: 'none' }}
                            disabled={loading}
                        >
                            Cancel
                        </Button>
                        <Button
                            variant="contained"
                            color="primary"
                            size="small"
                            onClick={saveChanges}
                            sx={{ borderRadius: '8px', textTransform: 'none' }}
                            disabled={loading}
                        >
                            {loading ? <CircularProgress size={20} /> : "Save Changes"}
                        </Button>
                    </>
                ) : (
                    <>
                        <Chip
                            icon={getStatusIcon(ticket.status)}
                            label={ticket.status}
                            size="small"
                            sx={{
                                backgroundColor: getStatusColor(ticket.status).bg,
                                color: getStatusColor(ticket.status).color,
                                borderRadius: '4px',
                                fontSize: '0.75rem',
                                fontWeight: 500
                            }}
                        />
                        <Button
                            variant="outlined"
                            size="small"
                            startIcon={<Edit size={14} />}
                            onClick={toggleEditMode}
                            sx={{ borderRadius: '8px', textTransform: 'none' }}
                            disabled={loading}
                        >
                            Edit
                        </Button>
                    </>
                )}
            </Box>
        </Box>
    );
};

export default TicketHeader;